import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { grey, red, yellow, blue } from '@material-ui/core/colors';

const styles = (theme) => ({
	question: {
		padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 4}px`,
		display: 'flex',
		alignItems: 'center',
		'& font[style="background-color:red"]': {
			background: `${red[500]} !important`
		},
		'& font[style="background-color:yellow"]': {
			background: `${yellow[500]} !important`
		}
	},
	num: {
		padding: '6px 12px',
		marginRight: theme.spacing.unit * 2,
		borderRadius: '50%',
		backgroundColor: grey[200],
		fontWeight: 600,
		display: 'flex',
		alignSelf: 'self-start'
	},
	answer: {
		'& span': {
			color: 'black'
		},
		'& span[data-bad]': {
			background: `${red[500]} !important`
		},
		'& span[data-soso]': {
			background: `${yellow[500]} !important`
		},
		'& span[data-ok]': {
			background: `${blue[200]} !important`
		},
		'& span[data-unknown]': {
			color: `${red[500]} !important`
		},
	}
});

class Question extends Component {
	render() {
		const { classes, text } = this.props;

		return (
			<div className={classes.question}>
				<Typography
					variant="subheading"
					className={classes.answer}
					dangerouslySetInnerHTML={{ __html: text }}
					color="default"
				/>
			</div>
		);
	}
}

Question.propTypes = {
	classes: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired
};

export default compose(
	withStyles(styles)
)(Question);
